import axiosInstance from '@/api/axiosInstance';
import { CreateQuizPayload, CreateQuizResponse } from './types';

/**
 * Create a new quiz
 * POST /api/learning-center/quizzes
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const createQuiz = async (
  payload: CreateQuizPayload
): Promise<CreateQuizResponse> => {
  try {
    const response = await axiosInstance.post<CreateQuizResponse>(
      '/api/learning-center/quizzes',
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating quiz:', error);
    throw error;
  }
};
